import {
  UserAddOutlined,
  UserOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Switch } from "antd";
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import React from "react";
import { post } from "../Libraries/Ajax/HttpService";
import { Component } from "react";
// import { injectStyle } from "react-toastify/dist/inject-style";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import back from "../assets/images/back.svg";
import { withNavigation } from "./withNavigation";
// injectStyle();
// toast.configure();

const mcdata_temp = JSON.parse(localStorage.getItem("MCData"));
class Water extends Component {
  state = {
    names: "",
    active: true,
    type: "",
    value: "",
    frequency: "",
    unit: "",
    display: "",
  };
  // componentDidMount() {
  //   const isMizuWatch = window.location.href.includes("mizuwatch.com");
  //   document.title = isMizuWatch ? "MizuWatch" : "MizuSmart";
  // }
  onNamesChange = (e) => {
    this.setState({
      names: e.target.value,
    });
  };
  onRedirection = (event) => {
    // window.history.back();
   this.props.navigate(-1);
  };

  onMouseClickpath = (event) => {
    this.props.navigate("/settings");
  };

  onselectMetermangement = () => {
    this.props.navigate("/metermanagement");
  };
  onselectClick = () => {
    this.props.navigate("/settingsuser");
  };
  onselectClicks = () => {
    this.props.navigate("/list");
  };
  onselectClickaccount = () => {
    this.props.navigate("/accountnames");
  };

  onActiveChange = (checked) => {
    this.setState({
      active: checked,
    });
  };

  onValueChange = (e) => {
    this.setState({
      value: e.target.value,
    });
  };

  onDisplayChange = (e) => {
    this.setState({
      display: e.target.value,
    });
  };
  onUnitChange = (e) => {
    this.setState({
      unit: e.target.value,
    });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      name: this.state.names,
      active: this.state.active,
      // Type:this.state.type,
      value: this.state.value,
      unit: this.state.unit,
      display_name: this.state.display,
      // Frequency:this.state.frequency,
    };
    post("apis/admin_settings", data).then(
      (response) => {
        console.log(response);

        toast.success("Admin Settings Added", {
          autoClose: 500,
        });

        // }
        this.props.navigate("/settingsuser");
      },
      (error) => {
        toast.error("Failed Saving", {
          autoClose: 3000,
        });
      }
    );
  };

  render() {
    return (
      <>
        {/* <ToastContainer /> */}
         {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
        <Header />
        <Main>
          <div>
            <div className="d-flex align-items-center justify-content-between flex-wrap mb-4">
              <div className="d-flex align-items-center ">
                <img
                  src={back}
                  alt=""
                  style={{ width: "10px" }}
                  onClick={this.onRedirection}
                />
                {/* <h3 className="mb-0 ms-3">Settings</h3> */}
                <div className="d-flex align-items-center">
                  <div
                    className="new-box-padding   align-self-center c-pointer "
                    onClick={this.onselectClick}
                    style={{ borderBottom: "2px solid #ccc" }}
                  >
                    {" "}
                    Settings
                  </div>
                  <div
                    className=""
                    style={{ width: "2px", height: "25px", background: "#ccc" }}
                  ></div>
                  <div
                    className="new-box-padding  text-blue  align-self-center c-pointer "
                    style={{
                      borderBottom: "2px solid #1998f0",
                      borderRadius: "0",
                    }}
                    onClick={this.onMouseClickpath}
                  >
                    {" "}
                    Add New Parameter
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="post">
            <form
              className="form-horizontal bg-white mx-auto login-form rounded p-5 border-2 shadow my-3"
              onSubmit={this.handleSubmit}
            >
              <div className="col-lg-5 m-auto">
                <div className="forms-inputs mt-3">
                  <span for="pwd">Name</span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Name"
                    value={this.state.names}
                    onChange={this.onNamesChange}
                    required
                  />
                </div>

                <div className="forms-inputs">
                  <span for="email">Value</span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Value"
                    value={this.state.value}
                    onChange={this.onValueChange}
                  />
                </div>

                <div className="forms-inputs">
                  <span for="unit">Unit</span>
                  <input
                    placeholder="Enter Unit"
                    value={this.state.unit}
                    onChange={this.onUnitChange}
                    className="form-control"
                  />
                </div>
                <div className="forms-inputs">
                  <span for="display">Display Name</span>
                  <input
                    placeholder="Enter Display Name"
                    value={this.state.display}
                    onChange={this.onDisplayChange}
                    className="form-control"
                  />
                </div>
                <div className="checkbox">
                  <span>
                    <b>Status</b>
                  </span>
                  <br />
                  <Switch defaultChecked onChange={this.onActiveChange} />
                </div>
                <div className="form-group mb-3">
                  <div className="col-sm-offset-2">
                    <button
                      type="submit"
                      className="btn w-100 btn-submit fs-20 mt-20"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </Main>
      </>
    );
  }
}

// export default Water;
export default withNavigation(Water);

